<template>
  <div>
    <el-dialog
      :visible.sync="$store.state.store_sv.svTalkDiaLogVisible"
      class="sv_talk_dialog"
      width="25%"
    >
      <span slot="title" class="dialog-header">
        <span class="sv_talk_title"> {{ this.$store.state.store_sv.chat_sv_name }}との内部チャット</span>
        <button
          type="button"
          class="el-dialog__headerbtn header-minbtn"
          @click="closeSvTalkDialog"
        >
          <i class="el-icon-minus" style="color: white"></i>
        </button>
      </span>
      <!-- <el-table
        :data="$store.state.store_sv.svTalkMessageList"
        :show-header="false"
        height="280px"
      >
        <el-table-column>
          <template slot-scope="scope"  v-if="
                  scope.row.questioner_id ==
                  $store.state.sysInit.manualChatQuestionerId && scope.row.issueId == $store.state.sysInit.manualChatModeIssueId
                ">
            <div
              style="padding-right: 5px"
              class="message_msg_sv_talk"
              :class="{
                left: scope.row.flag == 'right',
                right: scope.row.flag == 'left',
              }"
            >
           
              <div class="user_headshot" style="background-color: #f2f2f2">
                <img
                  :src="scope.row.sv_logo"
                  v-if="scope.row.flag == 'right'"
                />
                <img :src="$store.state.sysInit.operator_logo"  v-else />
              </div>
              <div class="user_msg">
                <span>
                  <div class="speaker">
                    {{ scope.row.userName }}
                  </div>
                  <div class="user_text">
                    <span v-html="scope.row.message"></span>
                  </div>
                </span>
                <br />
                <div style="padding-top: 10px; font-size: 12px; float: right">
                  {{ scope.row.messageTime }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table> -->

<div style="overflow:auto; height:280px">

  <span
        v-for="(menu, index) in this.$store.state.store_sv.svTalkMessageList"
        :key="index"
      >
        <template
          v-if="
            menu.questioner_id == $store.state.sysInit.manualChatQuestionerId &&
            menu.issueId == $store.state.sysInit.manualChatModeIssueId
          "
        >
          <div
            style="padding-right: 5px;padding-bottom:10px"
            class="message_msg_sv_talk"
            :class="{
              left: menu.flag == 'right',
              right: menu.flag == 'left',
            }"
          >
            <div class="user_headshot" style="background-color: #f2f2f2">
              <img :src="menu.sv_logo" v-if="menu.flag == 'right'" />
              <img :src="$store.state.sysInit.operator_logo" v-else />
            </div>
            <div class="user_msg">
              <span>
                <div class="speaker">
                  {{ menu.userName }}
                </div>
                <div class="user_text">
                  <span v-html="menu.message"></span>
                </div>
              </span>
              <br />
              <div style="padding-top: 10px; font-size: 12px; float: right">
                {{ menu.messageTime.replaceAll("-","/") }}
              </div>
            </div>
          </div>
        </template>
      </span>
</div>



      <span slot="footer" class="dialog-footer">
        <div class="footer-box-sv-talk">
          <div style="width: 15px; height: 30px; text-align: center"></div>
          <el-input
          type="textarea"
          resize="none"
         :autosize="{ minRows: 1, maxRows: 5 }"
            placeholder="テキストを入力"
            v-model="inputText"
          ></el-input>
          <div
            class="sv-talk-send"
            @click="svTalk()"
          >
            <img
              id="img"
              src="../assets/img/send.png"
              style="width: 30px; height: 28px; cursor: pointer"
            />
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const _ = require("lodash");
import moment from "moment";
export default {
  data() {
    return {
      dialogVisible: false,
      inputText: "",
    };
  },
  methods: {
    closeSvTalkDialog() {
      this.$store.state.store_sv.svTalkDiaLogVisible = false;
    },
    svTalk() {
      if (this.inputText != "") {
        let questioner_id = this.$store.state.sysInit.manualChatQuestionerId;
        let temp_sv = _.find(
          this.$store.state.store_sv.chat_sv_helper_info_list,
          function (o) {
            return o.questioner_id == questioner_id;
          }
        );
        if (temp_sv) {
          if (temp_sv.svExtension) {
            this.$store.dispatch("store_sv/svTalkSendMessage", {
              message: this.inputText,
              supervisorId: temp_sv.svExtension,
            });

            let svName = null;
            if (temp_sv.svName) {
              svName = temp_sv.svName;
            }
            let data_sv = {
              flag: "left",
              questioner_id: this.$store.state.sysInit.manualChatQuestionerId,
              svName: svName,
              svExtension: temp_sv.svExtension,
              message: this.inputText,
              issueId: this.$store.state.sysInit.manualChatModeIssueId,
              messageTime:moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
              userName:"あなた",
            };
            this.$store.state.store_sv.svTalkMessageList.push(data_sv);
            this.inputText = "";
          }
        } else {
          console.log("err");
        }
      }
    },
  },
};
</script>
<style lang="scss">
.footer-box-sv-talk {
  background-color: #94e3ff;
  //   background-image: linear-gradient(to right, 	#bbb 0%, 	#bbb 100%);
  // height: fit-content;
  // height: 45px;
  height: fit-content;
  padding: 10px 0px;
  // padding-top: 15px;
  // padding-bottom: 1px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .sv-talk-send {
    width: 45px;
    // height: 42px;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  // .el-input {
  //   width: 80%;
  //   margin: 0px 10px;
  // }
  .el-autocomplete {
    flex: 1;
    margin: 0px 0px;
  }
  .el-button--mini {
    margin: 0px 10px;
  }
  :deep(.el-autocomplete-suggestion li) {
    padding: 10px 0px;
    white-space: normal;
    line-height: normal;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    // height: 36px!important;
    padding: 5px 0px;
    font-size: 16px;
    color: inherit;
  }
}
.sv_talk_title{
  color: #174263;
  font-size: 14px;
}
</style>